const CHUNK_RELOAD_KEY = 'sl-chunk-reload';

/**
 * True when a production chunk or CSS file failed to load.
 *
 * @param {Error} [error]
 * @returns {boolean}
 */
export const isChunkLoadError = error => {
  if (!error) {
    return false;
  }
  const message = error.message || '';
  return (
    error.name === 'ChunkLoadError' ||
    /Loading chunk \d+ failed/i.test(message) ||
    /Loading CSS chunk/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
};

/**
 * Reload once after a chunk miss (stale deploy). Returns true if a reload
 * was started. A second miss in the same tab shows the error page instead.
 *
 * @param {Error} [error]
 * @param {{ sessionStorage?: Storage, location?: { reload: Function } }} [win]
 * @returns {boolean}
 */
export const reloadOnceOnChunkError = (error, win) => {
  if (!isChunkLoadError(error)) {
    return false;
  }
  const store = win?.sessionStorage || (typeof window !== 'undefined' ? window.sessionStorage : null);
  const location = win?.location || (typeof window !== 'undefined' ? window.location : null);
  if (!store || !location?.reload) {
    return false;
  }
  try {
    if (store.getItem(CHUNK_RELOAD_KEY)) {
      return false;
    }
    store.setItem(CHUNK_RELOAD_KEY, '1');
    location.reload();
    return true;
  } catch (e) {
    return false;
  }
};

export { CHUNK_RELOAD_KEY };
